import React, { Component } from 'react'
import DashboardContainer from 'containers/DashboardContainer'
import Button from 'components/common/Button'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import { changePollsTab, fetchPollList } from 'src/actions/timepoll'
import PollListContainer from './TimePoll/TimePollList/TimePollList'
import HeaderBar from 'components/common/HeaderBar/HeaderBar'

import styles from './time-poll-container.scss'
import addPollIcon from 'assets/icons/add-poll-icon.png'

class TimePollContainer extends Component {
  changeTab = type => {
    this.props.onChangeTab({ ...changePollsTab(), value: type })
  }

  getActiveComponent = () => {
    const { pollsTab } = this.props
    const components = {
      timePoll: <PollListContainer />,
      signUp: <PollListContainer type="su" />
    }

    return components[pollsTab]
  }

  componentDidMount() {
    const { getPollsList } = this.props
    getPollsList({ status: 'all', pollType: 'time' })
    getPollsList({ status: 'all', pollType: 'item' })
  }

  goCreatePage = () => {
    const { pollsTab, onChangeRouter } = this.props
    const router = {
      timePoll: () => onChangeRouter('/tp/create/'),
      signUp: () => onChangeRouter('/su/create/')
    }

    router[pollsTab]()
  }

  render() {
    const { pollsTab } = this.props

    return (
      <DashboardContainer>
        <div className={styles['poll-container']}>
          <HeaderBar menuIcon>
            <div className={styles['nav-title']}>polls & sign up list</div>
          </HeaderBar>
          <div className={styles['polls-header']}>
            <ul className={styles['polls-tabs-wrapper']}>
              <li
                className={cn(styles['polls-tabs-inner'], {
                  [styles['polls-tabs-inner-active']]: pollsTab === 'timePoll'
                })}
                onClick={() => this.changeTab('timePoll')}
              >
                time polls
              </li>
              <li
                className={cn(styles['polls-tabs-inner'], {
                  [styles['polls-tabs-inner-active']]: pollsTab === 'signUp'
                })}
                onClick={() => this.changeTab('signUp')}
              >
                sign up list
              </li>
            </ul>
            
            <div className={styles['button-wrapper']}>
              <Button className={styles['create-polls-button']} onClick={this.goCreatePage}>
                + Create {pollsTab === 'timePoll' ? 'time poll' : 'sign up list'}
              </Button>
            </div>
            <img
              src={addPollIcon}
              className={styles['create-polls-icon']}
              onClick={this.goCreatePage}
            />
          </div>
          <div className={styles['polls-component']}>{this.getActiveComponent()}</div>
        </div>
      </DashboardContainer>
    )
  }
}

TimePollContainer.propTypes = {
  onChangeTab: PropTypes.func,
  pollsTab: PropTypes.string,
  onChangeRouter: PropTypes.func,
  getPollsList: PropTypes.func
}

function mapStateToProps(state) {
  return {
    pollsTab: state.frontend.pollsTab
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeTab: params => dispatch(params),
    onChangeRouter: params => dispatch(routerActions.push(params)),
    getPollsList: params => dispatch(fetchPollList(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimePollContainer)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/TimePollContainer.jsx